function outcomesLink(organization_name, section) {
  return "/organizations/" + organization_name + "/outcomes" + section;
}

const DATES = "dates";
const FACILITIES = "facilities";
const CATEGORIES = "categories";
const ALL_FILTERS = [DATES, FACILITIES, CATEGORIES];

export default function metricDefinitions(organization_name, permissions) {
  return {
    general: {
      link: outcomesLink(organization_name, ""),
      name: "NARR Affiliate Account Data",
      enabledFilters: ALL_FILTERS,
      visible: true,
      metrics: [
        {
          title: "Number of Member Sober Livings",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "number_member_sober_livings",
          visible: true
        },
        {
          title: "Zip Code Distribution of Sober Livings",
          outcome_slug: "",
          description: '',
          format: "pie_chart",
          endpoint: "zip_code_distribution",
          visible: true
        },
        {
          title: "Submissions - Membership Form",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "membership_form",
          visible: true
        },
        {
          title: "Submissions - Resident Move In Form",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "resident_move_in",
          visible: true
        },

      ],
    },
    member_data: {
      link: outcomesLink(organization_name, "/member_data"),
      name: "Member Data",
      enabledFilters: ALL_FILTERS,
      visible: true,
      metrics: [
        {
          title: "Number of Residents Total",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "number_of_residents_total",
          visible: true
        },
        {
          title: "Number of Residents - Sober Living Member 1",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "number_of_residents_per_sober_living_1",
          visible: true
        },
        {
          title: "Number of Residents - Sober Living Member 2",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "number_of_residents_per_sober_living_2",
          visible: true
        },
        {
          title: "Number of Vacant Beds - Sober Living Member 1",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "number_of_vacant_beds_per_sober_living_1",
          visible: true
        },
        {
          title: "Number of Vacant Beds - Sober Living Member 2",
          outcome_slug: "",
          description: '',
          format: "number_horizontal_full",
          endpoint: "number_of_vacant_beds_per_sober_living_2",
          visible: true
        },
      ],
    },
  };
}
//






